// extracted by css-extract-rspack-plugin
export default {"CheckboxColumGrid":"DRfsh","CheckboxColumGrid--nogap":"Z65_Y"};